<template>
  <div>
    <v-row>
      <v-col cols="12">
        <add-responder :edit="edit" :email="email" @change="changeMode"/>
      </v-col>
      <v-col cols="12">
        <autoresponder-table @edit="editRule" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AddResponder from './AddResponder'
import AutoresponderTable from './AutoresponderTable'

export default {
  name: 'Autoresponders',
  components: {
    AddResponder,
    AutoresponderTable
  },
  data: () => ({
    edit: false,
    email: ''
  }),
  methods: {
    editRule (val) {
      this.edit = val.edit
      this.email = val.email
    },
    changeMode () {
      this.edit = false
    }
  }
}
</script>
